import { createFileRoute } from "@tanstack/react-router";

import { TrainingSettings } from "@/features/training/modules/training-settings/training-settings";
import { m } from "@/paraglide/messages.js";

export const Route = createFileRoute("/(private)/training/settings")({
  loader: () => ({ crumb: m.training_settings_title() }),
  component: TrainingSettings,
});
